import controller from './list.controller';
import template from './list.html';

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.reports.list', {
			controller,
			template,
			'url': '/list',
			'controllerAs': 'vm',
			'params': {
				'returnResult': {}
			}
			// ,
			// 'resolve': {
			// 	'ReturnReport': function (ReportComponent, $stateParams, Toast) {
			// 		'ngInject';

			// 		if (Object.keys($stateParams.returnResult).length > 0) {
			// 			const dates = {
			// 				'from': $stateParams.returnResult.date_from,
			// 				'to': $stateParams.returnResult.date_to
			// 			};

			// 			return ReportComponent.fetchReports($stateParams.returnResult.userId, dates, 1)
			// 				.then(function (response) {
			// 					if (response.errors) {
			// 						Toast.responseError(response.data.errors);
			// 					}
			// 					return response;
			// 				});
			// 		}
			// 	}
			// }
		});
}

export default RouteConfig;



/** WEBPACK FOOTER **
 ** ./client/private/reports/list/list.route.js
 **/